import { useState, useEffect } from "react";

const useKeyPressToggle = () => {

    const [isConfig, setIsConfig] = useState(false);
    const [isDebug, setIsDebug] = useState(false);
    const [isMaterialEdit, SetIsMaterialEdit] = useState(false);
    const [isAo, setIsAo] = useState(true);

    useEffect(() => {

        const handleKeyPress = (event) => {
            //Press Alt + z for configurator mode.
            if (
                (event.altKey && event.key === "z") ||
                event.key === "Z" ||
                event.which === 90
            ) {
                setIsConfig((prev) => !prev);
            }
            //Press Alt + y for debugging mode.
            if (
                (event.altKey && event.key === "y") ||
                event.key === "Y" ||
                event.which === 89
            ) {
                setIsDebug((prev) => !prev);
            }
            if (
                (event.altKey && event.key.toLowerCase() === "m") ||
                event.which === 77
            ){
                SetIsMaterialEdit((prev) => !prev);
            }
            if (
                (event.altKey && event.key.toLowerCase() === "s") ||
                event.which === 83
            ){
                setIsAo((prev) => !prev);
            }
        };

        window.addEventListener("keydown", handleKeyPress);

        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
        
    }, []);

    return { isConfig, isDebug, isMaterialEdit, isAo };
};

export default useKeyPressToggle;
